<template>
  <div class="clinicalSetting">
    <el-menu :default-active="tabActive.toString()" mode="horizontal" @select="tabSelect">
      <template v-for="(item, index) in tabList">
        <el-menu-item :index="index.toString()">{{ item.name }}</el-menu-item>
      </template>
    </el-menu>
    <div class="content">
      <component :is="tabList[tabActive].component"></component>
    </div>
  </div>
</template>

<script>
  import registrationFee from './components/registrationFee.vue'
  import physioProject from './components/physioProject.vue'
  import processingFee from './components/processingFee.vue'
  import deliveryFee from './components/deliveryFee.vue'
  export default {
    name: 'clinicalSetting',
    components: {
      registrationFee,
      physioProject,
      processingFee,
      deliveryFee
    },
    data() {
      return {
        tabActive: 0,
        tabList: [
          { id: 1, name: '挂号费', component: 'registrationFee' },
          { id: 2, name: '理疗项目', component: 'physioProject' },
          { id: 3, name: '加工费', component: 'processingFee' },
          { id: 4, name: '配送费', component: 'deliveryFee' }
        ]
      }
    },
    methods: {
      tabSelect (index) {
        this.tabActive = index
      }
    }
  }
</script>

<style lang="less" scoped>
  .clinicalSetting {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
  }

  .content {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    min-height: 0px;
  }
</style>
